import PropTypes from 'prop-types';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import websiteActions from '../../../redux/websites/actions';

import './WebsiteWidgetConfigEditor.scss';

function WidgetConfigEditor(props) {
  const { page, website, fetching, widgetConfig, onChange, actions } = props;
  const { type, editor: Editor } = page;

  useEffect(() => {
    // Clear out tmpWebsite on first load
    actions.updateWebsiteTmpRequest({ tmpWebsite: {} });
  }, []);

  if (!widgetConfig) {
    return null;
  }

  const formData = get(widgetConfig, `${type}`);

  // API tab doesn't require formData
  if (!formData && type !== 'API') {
    return null;
  }

  const onFormDataChange = (newFormData) =>
    onChange({ ...widgetConfig, [type]: newFormData });

  return (
    <div className="widget-config-editor">
      {fetching && <div className="widget-loader" />}
      <Editor
        website={website}
        page={page}
        formData={formData}
        onChange={onFormDataChange}
      />
    </div>
  );
}

WidgetConfigEditor.propTypes = {
  website: PropTypes.object,
  fetching: PropTypes.bool,
  widgetConfig: PropTypes.object,
  onChange: PropTypes.func,
  page: PropTypes.object,
  actions: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...websiteActions,
    },
    dispatch,
  ),
});

export default connect(null, mapDispatchToProps)(WidgetConfigEditor);
